import { RuleControllerMapper } from './rule-mapper';
import { CQMasterDataStore } from '../../../store/cq-master-data.store';
import { CQPicklistValueSourceController } from '../../../common/rules/picklist-value-source/picklist-value-source.controller';
import { CQAppConstant } from '../../../app-constants';
import { Utility } from '../../../common/utility';
import { CQUITypeValueSourceController } from '../../../common/rules/uiType-value-source/uitype-value-source-controller';

export class RuleEngineController {

    private readonly cqUtilityClass: Utility;

    constructor() {
        this.cqUtilityClass = new Utility();
    }

    /**
     * @memberof RuleEngineController
     */
    public getRuleController = (ruleType: string, ruleObject: any) => {
        if (ruleType) {
            const ruleObj: any = RuleControllerMapper[ruleType].getControllerInstance(ruleObject);
            return ruleObj.ruleJSON;
        }
    };

    /**
     * @private
     * @memberof RuleEngineController
     */
    public addDynamicSource = (objectName: string, selectedRuleType: string, rule: any, templateName: string, toggleModalVisibility: Function) => {
        this.addElements(objectName, selectedRuleType, this.cqUtilityClass.createObjectDeepCopy(rule));
        const ruleObject = this.getRuleController(selectedRuleType, rule);
        CQMasterDataStore.DynamicSourceValue.addDynamicSource(objectName, ruleObject);
        const dynamicSourceObject = this.returnDynamicSourceObject(CQMasterDataStore.DynamicSourceValue.FieldDynamicSourceData);
        CQMasterDataStore.OutputConfig.setDynamicSource(templateName, dynamicSourceObject);
        const lookupFilterObject = this.returnLookupFilterFieldObject(CQMasterDataStore.DynamicSourceValue.FieldDynamicSourceData);
        CQMasterDataStore.OutputConfig.setLookupFilters(templateName, lookupFilterObject);
        CQMasterDataStore.OutputConfig.setRuleElements(templateName, CQMasterDataStore.RuleElements.FieldRuleElement);
        // if (rule.hasOwnProperty('additionalFields')) {
        //     CQMasterDataStore.OutputConfig.setAdditionalFields(templateName, rule.additionalFields);
        // }
        toggleModalVisibility();
    }


    public addInputRules = (objectName: string, selectedRuleType: string, rule: any, templateName: string, toggleModalVisibility: Function) => {
        this.addElements(objectName, selectedRuleType, this.cqUtilityClass.createObjectDeepCopy(rule));
        const ruleObject = this.getRuleController(selectedRuleType, rule);
        CQMasterDataStore.RulesObject.addEditRule(objectName, ruleObject);
        const updatedFieldRuleObject = this.formatInputRuleObject(CQMasterDataStore.RulesObject.FieldRuleObject);
        CQMasterDataStore.OutputConfig.setInputRules(templateName, updatedFieldRuleObject);
        CQMasterDataStore.OutputConfig.setRuleElements(templateName, CQMasterDataStore.RuleElements.FieldRuleElement);
        // if (rule.hasOwnProperty('additionalFields')) {
        //     CQMasterDataStore.OutputConfig.setAdditionalFields(templateName, rule.additionalFields);
        // }
        toggleModalVisibility();
    }



    /**
    * @private
    * @memberof ApplyRuleModalComponent
    */
    public addFormulaField = (objectName: string, selectedRuleType: string, rule: any, templateName: string, toggleModalVisibility: Function) => {
        this.addElements(objectName, selectedRuleType, this.cqUtilityClass.createObjectDeepCopy(rule));
        const ruleObject = this.getRuleController(selectedRuleType, rule);
        CQMasterDataStore.FormulaField.addEditFormulaField(objectName, ruleObject);
        CQMasterDataStore.OutputConfig.setFormulaField(templateName, objectName, ruleObject[selectedRuleType]);
        CQMasterDataStore.OutputConfig.setRuleElements(templateName, CQMasterDataStore.RuleElements.FieldRuleElement);
        // if (rule.hasOwnProperty('additionalFields')) {
        //     CQMasterDataStore.OutputConfig.setAdditionalFields(templateName, rule.additionalFields);
        // }
        toggleModalVisibility();
    }

    /**
    * @private
    * @memberof ApplyRuleModalComponent
    */
    public addLookupFilterField = (objectName: string, selectedRuleType: string, rule: any, templateName: string, toggleModalVisibility: Function) => {
        const ruleCopy = this.cqUtilityClass.createObjectDeepCopy(rule);
        delete ruleCopy['lookupFields'];
        this.addElements(objectName, selectedRuleType, ruleCopy);
        const ruleObject = this.getRuleController(selectedRuleType, rule);
        CQMasterDataStore.RulesObject.addEditRule(objectName, ruleObject);
        CQMasterDataStore.OutputConfig.setlookupFilters(templateName, objectName, ruleObject['lookup filter']);
        CQMasterDataStore.OutputConfig.setRuleElements(templateName, CQMasterDataStore.RuleElements.FieldRuleElement);
        toggleModalVisibility();
    }

    /**
     * @param {string} fieldName
     * @param {string} ruleType
     * @memberof RuleEngineController
     */
    public deleteAppliedRule(fieldName: string, ruleType: string, selectedTemplateName: string) {
        const componentEvents = Object.keys(CQAppConstant.COMPONENT_EVENT_RULES_MAP);
        const componentRules = componentEvents.map((eventName:string)=> CQAppConstant.COMPONENT_EVENT_RULES_MAP[eventName].key);
        const inputRules = [...componentRules, ...CQAppConstant.RULE_TYPES_OBJECT.DEFAULT, 'transfer'];
        const isInputRules = inputRules.includes(ruleType);
        if (isInputRules) {
            CQMasterDataStore.OutputConfig.deleteRule(selectedTemplateName, fieldName, ruleType, 'inputRules');
        } else if (ruleType === 'Formula Field - Hyperlink') {
            CQMasterDataStore.OutputConfig.deleteRule(selectedTemplateName, fieldName, ruleType, 'formulaFields');
        } else if (ruleType === 'dynamicSource') {
            CQMasterDataStore.OutputConfig.deleteRule(selectedTemplateName, fieldName, ruleType, ruleType);
            CQMasterDataStore.OutputConfig.deleteRule(selectedTemplateName, fieldName, 'fields', 'lookupFilters');
        }
        else if (ruleType === 'lookupFilter') {
            CQMasterDataStore.OutputConfig.deleteRule(selectedTemplateName, fieldName, '', 'lookupFilters');
        }
        else {
            CQMasterDataStore.OutputConfig.deleteRule(selectedTemplateName, fieldName, ruleType, ruleType);
        }

        CQMasterDataStore.RulesObject.deleteAppliedRule(fieldName, ruleType);
        CQMasterDataStore.RuleElements.deleteAppliedRule(selectedTemplateName, fieldName, ruleType);
        CQMasterDataStore.Details.setAppliedRuleObject();

    }

    /**
     * @param {string} objectName
     * @param {*} newRuleObject
     * @memberof RuleEngineController
     */
    public editAppliedRule(objectName: string, newRuleObject: any) {
        CQMasterDataStore.RulesObject.addEditRule(objectName, newRuleObject);
    }
 
    /**
     * @param {string} templateName
     * @param {string} categoryName
     * @memberof RuleEngineController
     */
    public setPickListvalueSource(templateName: string, categoryName: string) {

        const pickListValueSourceCtrl = new CQPicklistValueSourceController();
        pickListValueSourceCtrl.setPicklistValueSource(templateName, categoryName);
    }

    /**
     * @param { String } templateName
     * @param { Object } uiTypeDetail
     * @memberof RuleEngineController
     */
    public setUITypeSource(templateName: string, uiTypeDetail: {}) {

        const uiTypeValueSourceCtrl = new CQUITypeValueSourceController();
        uiTypeValueSourceCtrl.setUITypeSource(templateName, uiTypeDetail);
    }

    /**
     * @memberof RuleEngineController
     */
    public deletePicklistValueSource = (selectedTemplateName: string) => {
        const fieldObj: any = CQMasterDataStore.Details.selectedFieldDetailsObject;
        const picklistObject = { ...CQMasterDataStore.PicklistValueSource.FieldPickListData };
        CQMasterDataStore.PicklistValueSource.deletePicklistValueSource(fieldObj.fullName, picklistObject[fieldObj.fullName]);
        const fieldRuleElement: any = { ...CQMasterDataStore.RuleElements.FieldRuleElement[fieldObj.fullName] };
        if (fieldRuleElement && fieldRuleElement.hasOwnProperty('PicklistValueSource')) {
            CQMasterDataStore.RuleElements.deleteAppliedRule(selectedTemplateName, fieldObj.fullName, 'PicklistValueSource');
        }
        const outputConfig = CQMasterDataStore.OutputConfig.getStoreData(selectedTemplateName);

        if (outputConfig.picklistValueSource.hasOwnProperty(fieldObj.fullName)) {
            CQMasterDataStore.OutputConfig.deleteRule(selectedTemplateName, fieldObj.fullName, 'picklistValueSource', 'picklistValueSource');
        }

    }

    /**
     * @memberof RuleEngineController
     */
    public deleteUITypeValueSource = (selectedTemplateName: string) => {
        const fieldObj: any = CQMasterDataStore.Details.selectedFieldDetailsObject;
        CQMasterDataStore.UITypeSource.deleteUITypeValueSource(fieldObj.fullName);
        const fieldRuleElement: any = { ...CQMasterDataStore.RuleElements.FieldRuleElement[fieldObj.fullName] };
        if (fieldRuleElement && fieldRuleElement.hasOwnProperty('UITypeValueSource')) {
            CQMasterDataStore.RuleElements.deleteAppliedRule(selectedTemplateName ,fieldObj.fullName, 'UITypeValueSource');
        }

        if (fieldRuleElement && fieldRuleElement.hasOwnProperty('LookupFilter')) {
            CQMasterDataStore.RuleElements.deleteAppliedRule(selectedTemplateName ,fieldObj.fullName, 'LookupFilter');
        }

        const outputConfig = CQMasterDataStore.OutputConfig.getStoreData(selectedTemplateName);
        if (outputConfig.uiType.hasOwnProperty(fieldObj.fullName)) {
            CQMasterDataStore.OutputConfig.deleteRule(selectedTemplateName, fieldObj.fullName, 'uiType', 'uiType');
        }

        if (outputConfig.lookupFilters.hasOwnProperty(fieldObj.fullName)) {
            CQMasterDataStore.OutputConfig.deleteRule(selectedTemplateName, fieldObj.fullName, 'fields', 'lookupFilters');
        }

    }

    /**
     * @memberof RuleEngineController
     */
    public addElements = (ObjectName: string, ruleType: string, ruleObject: any) => {

        CQMasterDataStore.RuleElements.setRuleElementObject(ObjectName, ruleType, ruleObject);
    }

    public formatInputRuleObject = (ruleObject: any) => {

        // let ruleData = null;
        let ruleObjectCopy = this.cqUtilityClass.createObjectDeepCopy(ruleObject);
        Object.keys(ruleObject).forEach((field) => {
            Object.keys(ruleObject[field]).forEach((rule) => {
                if (rule === 'Formula Field - Hyperlink'
                    || rule === 'Formula Field - Image'
                    || rule === 'lookup filter'
                ) {
                    // ruleData = ruleObject[field][rule];
                    const fieldObject = { ...ruleObjectCopy[field] };
                    delete fieldObject[rule];
                    ruleObjectCopy[field] = { ...fieldObject };
                }
            });
            if (field === 'componentLayout') {
                const fieldObject = { ...ruleObjectCopy[field] };
                delete ruleObjectCopy[field];

                Object.keys(fieldObject).forEach((rule) => {
                    Object.keys(fieldObject[rule]).forEach((componentEvent) => {
                        if (!ruleObjectCopy[componentEvent]) {
                            ruleObjectCopy[componentEvent] = {};
                        }
                        Object.keys(fieldObject[rule][componentEvent]).forEach((ruleType) => {
                            ruleObjectCopy[componentEvent][ruleType] = fieldObject[rule][componentEvent][ruleType];
                        });
                    });
                });
            }
        });

        return ruleObjectCopy;
    }

    /**
     * @memberof RuleEngineController
     */
    public returnDynamicSourceObject = (ruleObject: any) => {
        let rulesObj: any = {};
        Object.keys(ruleObject).forEach((field) => {
            rulesObj = { ...rulesObj, [field]: ruleObject[field].DynamicSource };
        });
        return rulesObj;
    }

    /**
     * @memberof RuleEngineController
     */
    public returnLookupFilterFieldObject = (ruleObject: any) => {
        let rulesObj: any = {};
        Object.keys(ruleObject).forEach((field) => {
            rulesObj = { ...rulesObj, [field]: ruleObject[field].LookupFilter };
        });
        return rulesObj;
    }

}
